import React, { Component } from "react";
import { featureList } from "./FeatureList";
import Select from "react-select";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";

class FAQComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: null,
      feedbackList: [],
      showAnswer: "",
    };
  }

  handleSelectionChange = (elem) => {
    this.setState({
      selectedOption: elem,
    });
    this.loadData();
  };

  loadData = () => {
    setTimeout(() => {
      axios({
        method: "post",
        url: HOST_URL + `/api/getfeedback`,
      })
        .then((response) => {
          this.setState({
            feedbackList: response.data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }, 400);
  };

  clickHandler = (index) => {
    if (this.state.showAnswer === index) {
      this.setState({ showAnswer: null });
    } else {
      this.setState({ showAnswer: index });
    }
  };

  render() {
    return (
      <div>
        <div style={{ textAlign: "center" }}>
          <h1 style={{ fontWeight: "bold" }}>
            Frequently Asked Questions (FAQ)
          </h1>
        </div>
        <div className="row align-items-centre">
          <div style={{ marginLeft: "auto", marginRight: "auto" }}>
            <p
              style={{
                fontWeight: "bold",
                // width: "500px",
                textAlign: "center",
              }}
            >
              Please select a feature to see its FAQ:
            </p>

            <Select
              classNamePrefix={"typeahead-select"}
              value={this.state.selectedOption}
              onChange={this.handleSelectionChange}
              options={featureList.map((item) => {
                return { value: item, label: item };
              })}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              placeholder="Select feature"
            />
          </div>
        </div>
        <br />
        <div style={{ height: "30vh", overflowY: "auto" }}>
          {this.state.feedbackList
            .filter((item) => {
              return (
                item.Feature == this.state.selectedOption.value &&
                item.IsFaq === true
              );
            })
            .map((item, index) => {
              return (
                <div key={"FAQ-List" + index}>
                  <div
                    className="row "
                    style={{
                      backgroundColor: "#edf0f2",
                      borderLeft: "2px solid #92278f",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                      marginLeft: "10px",
                      marginRight: "10px",
                      cursor: "pointer",
                    }}
                    onClick={this.clickHandler.bind(this, index)}
                  >
                    <h2
                      style={{
                        fontWeight: "bold",
                        fontSize: 40,
                        color: "#92278f",
                        alignSelf: "center",
                        margin: 0,
                      }}
                    >
                      Q.
                    </h2>
                    <p style={{ alignSelf: "center", margin: 0 }}>
                      {item.Feedback}
                    </p>
                  </div>
                  {this.state.showAnswer === index ? (
                    <div
                      className="row"
                      style={{
                        borderLeft: "2px solid #0072bc",
                        paddingLeft: "10px",
                        paddingRight: "10px",
                        marginLeft: "10px",
                        marginRight: "10px",
                      }}
                    >
                      <h2
                        style={{
                          fontWeight: "bold",
                          fontSize: 40,
                          color: "#0072bc",
                          alignSelf: "center",
                          margin: 0,
                        }}
                      >
                        A.
                      </h2>
                      <p style={{ alignSelf: "center", margin: 0 }}>
                        {item.Comment}
                      </p>
                    </div>
                  ) : (
                    () => {}
                  )}

                  {/* <p>
                  Answer {index + 1}: {item.Comment}
                </p> */}
                  <br />
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

export default FAQComponent;
